export const formatDurationDHMS = (minutes) => {
    const total = Math.max(0, Number(minutes) || 0);
    const days = Math.floor(total / 1440);
    const hours = Math.floor((total % 1440) / 60);
    const mins = Math.floor(total % 60);

    const parts = [];
    if (days > 0) {
        parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`);
    }
    if (hours > 0 || parts.length > 0) {
        parts.push(`${hours} ${hours === 1 ? 'Hour' : 'Hours'}`);
    }
    if (mins > 0 || parts.length === 0) {
        parts.push(`${mins} ${mins === 1 ? 'Minute' : 'Minutes'}`);
    }

    return parts.join(' ');
};
